import { render, staticRenderFns } from "./OnlineWaTemplateParser.vue?vue&type=template&id=dfbc978c&scoped=true&"
import script from "./OnlineWaTemplateParser.vue?vue&type=script&lang=js&"
export * from "./OnlineWaTemplateParser.vue?vue&type=script&lang=js&"
import style0 from "./OnlineWaTemplateParser.vue?vue&type=style&index=0&id=dfbc978c&prod&lang=scss&scoped=true&"
import style1 from "./OnlineWaTemplateParser.vue?vue&type=style&index=1&id=dfbc978c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbc978c",
  null
  
)

export default component.exports